/* ohm-bottom-furniture.js — OHM ADDITION (not Concept).

   Publishes --ohm-bottom-furniture-height on <html>: the height of the tallest
   sticky bar the theme parks above the mobile dock. The Shopify Inbox chat
   launcher uses it to stay clear of them — see the shopify-chat rule in
   mobile-dock.css for the full reasoning.

   Why measure rather than hardcode: these bars are lifted by the dock height
   when the dock is up, so they travel into whatever fixed offset the launcher
   would otherwise use. Their heights are also content-dependent — the buy bar
   wraps to the product title and the selected variant's option text.

   Both bars are Concept's, and normally only one is present on a given page:
     .product-sticky-form   PDP buy bar        (~116px)
     .facet-sticky          collection filter  (~56px)
   Max rather than sum, so a page that rendered both still resolves to a single
   sensible clearance. On a page with neither (the homepage) it publishes 0 and
   the launcher falls back to clearing just the dock. */
(() => {
  const SELECTORS = ['.product-sticky-form', '.facet-sticky'];
  const root = document.documentElement;
  const observed = new WeakSet();
  let observer = null;

  const measure = () => {
    let tallest = 0;
    for (const selector of SELECTORS) {
      for (const el of document.querySelectorAll(selector)) {
        tallest = Math.max(tallest, el.getBoundingClientRect().height);
      }
    }
    root.style.setProperty('--ohm-bottom-furniture-height', `${tallest.toFixed(1)}px`);
  };

  const track = () => {
    measure();
    if (!('ResizeObserver' in window)) return;
    observer = observer || new ResizeObserver(measure);
    for (const selector of SELECTORS) {
      for (const el of document.querySelectorAll(selector)) {
        if (observed.has(el)) continue;
        observed.add(el);
        observer.observe(el);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track, { once: true });
  } else {
    track();
  }

  // The theme editor re-renders whole sections, replacing these elements.
  document.addEventListener('shopify:section:load', track);
})();
